import { getMaxProductQty } from '@commerce-cart-webcomponents/sdk';
import { AddToCartButtonType } from '@commerce-cart-webcomponents/ui-composite';
import { QuantityStepper, QuantityStepperSize } from '@nextgen-web-framework/all';
import { useState } from 'react';
import AddToCartButton from '../AddToCartButton/AddToCartButton';
import styles from './AddToCartWithStepper.module.scss';
import { type AddToCartWithStepperProps } from './types/propsType';

export const AddToCartWithStepper = ({
  entryObj,
  onProductAddedCb = () => null,
  miniusButtonDisabled,
  plusButtonDisabled,
  overrideClassName = '',
  addToCartButtonDisable,
  disableQtyStepper = false,
  size,
  isMinProjection = false,
  ...rest
}: AddToCartWithStepperProps) => {
  const [count, setCount] = useState(1);
  const maxProductCount = getMaxProductQty();

  return (
    <div
      className={`${styles['add-to-cart-stepper-component']} ${overrideClassName}`}
      data-testid="add-to-cart-stepper-component"
    >
      <div className={styles['stepper-width']} data-testid="add-to-cart-stepper">
        <QuantityStepper
          count={count}
          maxLength={String(maxProductCount).length}
          maxCount={maxProductCount}
          size={QuantityStepperSize.MEDIUM}
          minCount={0}
          inputChangeHandler={(qty: number) => {
            setCount(qty);
            return 0;
          }}
          plusClickHandler={(qty: number) => {
            setCount(qty);
            return 0;
          }}
          minusClickHandler={(qty: number) => {
            setCount(qty);
            return 0;
          }}
          disableMinusButton={miniusButtonDisabled}
          disablePlusButton={plusButtonDisabled}
          disabled={disableQtyStepper}
        />
      </div>

      <div className={styles['add-width']} data-testid="add-to-cart-with-stepper-atc-btn">
        <AddToCartButton
          {...rest}
          size={size}
          disabled={addToCartButtonDisable}
          onProductAddedCb={(...args) => {
            onProductAddedCb?.(...args);
            setCount(1);
          }}
          entryObj={{ ...entryObj, quantity: count }}
          isMinProjection={isMinProjection}
          addToCartButtonType={AddToCartButtonType.ADD_TO_CART_BUTTON_WITHSTEPPER}
        />
      </div>
    </div>
  );
};

export type { AddToCartWithStepperProps };
